<template>
  <header class="consultation-record-header">
    <div class="consultation-record-header__info">
      <div class="consultation-record-header__heading">
        <h3>{{ title }}</h3>
        <span class="consultation-record-header__time">{{ time }}</span>
      </div>
      <p>{{ medicalRecord.professional?.prof_name }}</p>
      <span class="consultation-record-header__status">
        <i :class="editable ? 'bi bi-unlock' : 'bi bi-lock'" aria-hidden="true"></i>
        {{ medicalRecord.shared_readonly ? 'Compartilhado · somente leitura' : editable ? 'Liberado para alteração' : 'Somente leitura' }}
      </span>
    </div>
    <div class="consultation-record-header__actions"><slot /></div>
  </header>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ConsultationRecordHeader',
  props: {
    medicalRecord: { type: Object, required: true },
    title: String,
    editable: Boolean,
  },
  computed: {
    time() { return this.medicalRecord.schedule?.sched_time?.slice(0, 5) || moment(this.medicalRecord.medrec_date_time).format('HH:mm'); },
  },
};
</script>

<style scoped>
.consultation-record-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; padding: 20px; background: #fff; border-bottom: 1px solid #efedf2; border-radius: 12px 12px 0 0; }
.consultation-record-header__info { min-width: 0; }
.consultation-record-header__heading { display: flex; align-items: baseline; flex-wrap: wrap; gap: 10px; }
.consultation-record-header h3 { margin: 0; font-size: 15px; font-weight: 600; color: #302b38; }
.consultation-record-header__time { font-size: 12px; color: #817b89; }
.consultation-record-header p { margin: 6px 0; font-size: 12px; color: #706b79; }
.consultation-record-header__status { display: inline-flex; gap: 5px; align-items: center; font-size: 11px; color: #817b89; }
.consultation-record-header__actions { flex-shrink: 0; }
@media (max-width: 575px) {
  .consultation-record-header { flex-direction: column; padding: 16px; }
}
</style>
